export const ATTACHMENT_IS_LOADED_PERCENT = 100;
